import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ImageCompressionService {
  compress(file: File, maxBytes = 25 * 1024): Promise<File> {
    if (file.size <= maxBytes) {
      return Promise.resolve(file);
    }

    return new Promise((resolve, reject) => {
      const image = new Image();
      const objectUrl = URL.createObjectURL(file);

      image.onload = () => {
        URL.revokeObjectURL(objectUrl);
        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const context = canvas.getContext('2d');

        if (!context) {
          reject(new Error('Canvas is not available.'));
          return;
        }

        context.drawImage(image, 0, 0);
        let quality = 0.9;

        const tryQuality = () => {
          canvas.toBlob((blob) => {
            if (!blob) {
              reject(new Error('Image conversion failed.'));
              return;
            }

            if (blob.size <= maxBytes) {
              const fileName = file.name.replace(/\.[^.]+$/, '') + '.jpg';
              resolve(new File([blob], fileName, { type: 'image/jpeg' }));
              return;
            }

            if (quality <= 0.1) {
              reject(new Error('Image cannot be reduced to the requested size without changing resolution.'));
              return;
            }

            quality = Math.max(0.1, quality - 0.1);
            tryQuality();
          }, 'image/jpeg', quality);
        };

        tryQuality();
      };

      image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Image could not be read.'));
      };
      image.src = objectUrl;
    });
  }
}
